import type { ValidationResultType } from 'src/types/validation';

export const DEFAULT_ERROR_MESSAGE = 'Error';

interface ValidationResult {
  isValid: boolean;
  errorMessages: string[];
}

export default (validationResult?: ValidationResultType): ValidationResult => {
  const result: ValidationResult = {
    isValid: true,
    errorMessages: [],
  };

  if (typeof validationResult === 'boolean') {
    result.isValid = validationResult;
    if (!validationResult) {
      result.errorMessages.push(DEFAULT_ERROR_MESSAGE);
    }
  }

  if (typeof validationResult === 'string') {
    result.isValid = false;
    result.errorMessages.push(validationResult);
  }

  if (Array.isArray(validationResult) && validationResult.length > 0) {
    result.isValid = false;
    result.errorMessages.push(...validationResult);
  }
  return result;
};
